export const deleteCookie = (name, path = "/", domain = "") => {
    let cookieString = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT;`;

    if (path) {
        cookieString += ` path=${path};`;
    }
    if (domain) {
        cookieString += ` domain=${domain};`;
    }

    document.cookie = cookieString;
};
